export default "__VITE_ASSET__D4_5rrur__"